<template>
    <modal
        :style="{ 'z-index': zIndex }"
        name="general"
        height="auto"
        width="95%"
        :max-width="450"
        :adaptive="true"
        @before-open="beforeOpen"
    >
        <div class="general-body">
            <span v-if="showCloseButton" class="close-button" @click="$modal.hide('general')">x</span>
            <h2 v-if="title">{{ title }}</h2>
            <p :class="contentClass" v-html="content"/>
            <div v-if="button" class="text-center">
                <button class="btn btn-purple" @click="$modal.hide('general')">{{ button }}</button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'GeneralModal',
    data() {
        return {
            button: '',
            content: '',
            contentClass: '',
            showCloseButton: true,
            title: '',
            zIndex: 0
        }
    },
    methods: {
        beforeOpen(event) {
            this.button = event.params.button;
            this.content = event.params.content;
            this.contentClass = event.params.contentClass;
            this.showCloseButton = event.params.showCloseButton == undefined ? true : event.params.showCloseButton;
            this.title = event.params.title;
            this.zIndex = event.params.zIndex || 999
        }
    }
}
</script>

<style lang="scss">
.v--modal-overlay[data-modal="general"] {
    background-color: rgba(0, 0, 0, 0.7);

    .v--modal-box {
        background-color: transparent;
        border: 1px solid white;
        color: white;
        text-align: center;

        .general-body {
            background-color: rgba(17, 17, 15, 0.8);
            color: #fff;
            font-family: "Akkurat-Light";
            font-size: 14px;
            padding: 30px;
            position: relative;

            p + div {
                margin-top: 20px;
            }

            .close-button {
                cursor: pointer;
                font-size: 18px;
                line-height: 18px;
                position: absolute;
                right: 10px;
                top: 10px;
            }

            .btn-purple {
                padding: 10px 58px;
            }
        }
    }
}
</style>
